import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
// import './custom.scss';
import App from './App';
import Navbar from './Navbar';
import Footer from './footer';
// import 'bootstrap/dist/css/bootstrap.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <Navbar/> */}
    <div class='imge imge-content'>
      <div class='content'>
       <App />
    </div>
    </div>
      {/* <Component {...pageProps} /> */}
    {/* <Footer/> */}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
